import { Children, cloneElement, type FC, type PropsWithChildren, type ReactElement } from 'react';
import { logger } from '@zep/core-logger';
import { type EventProperties } from '@/utils/analytics';
export type ClickTrackingProps = {
  eventName?: string;
  eventProperties?: EventProperties;
};
export const ClickTracking: FC<PropsWithChildren<ClickTrackingProps>> = ({
  eventName,
  eventProperties,
  children
}) => {
  const handleClick = (event: MouseEvent) => {
    if (eventName) {
      logger.track(eventName, eventProperties);
    }

    // 자식 컴포넌트의 기존 onClick 이벤트 호출
    const child = Children.only(children) as ReactElement;
    const childOnClick = (child?.props as any).onClick;
    if (typeof childOnClick === 'function') {
      childOnClick(event);
    }
  };
  return cloneElement(children as React.ReactElement, {
    onClick: handleClick
  });
};